import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useListTenants } from './use-list-tenants';

const useCurrentTenant = () => {
  const [tenantId, setTenantId] = useState<string | undefined>();
  const { data, loading } = useListTenants();
  const params = useParams();

  useEffect(() => {
    if (params.tenantId) {
      setTenantId(params.tenantId);
    }
  }, [params]);

  return {
    tenantId,
    tenant:
      !loading && data
        ? data.listTenants.find((t) => t.id === tenantId)
        : undefined,
  };
};

export { useCurrentTenant };
